import { render, staticRenderFns } from "./_Douleurs.vue?vue&type=template&id=b48bf60e&"
import script from "./_Douleurs.vue?vue&type=script&lang=ts&"
export * from "./_Douleurs.vue?vue&type=script&lang=ts&"
import style0 from "./_Douleurs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports